import * as authSelectors from '@redux/reducers/auth';
import { useState } from 'react';
import { Edit2 } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button, Tooltip } from 'reactstrap';
import { appIntl } from '../../../utility/context/IntlGlobalProvider';

interface Props {
  isDisabled?: boolean;
  id?: any;
  permissions?: any[];
  handleClick: () => any;
  tooltipMessage?: string;
  visible?: boolean;
}

const EditButton = (props: Props) => {
  const store = useSelector((state) => state);
  const { id = '', isDisabled, handleClick, tooltipMessage, permissions, visible = true } = props;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (!permissions || authSelectors.getAuthUserHasPermissionsAny(store, permissions)) &&
    visible ? (
    <Button.Ripple
      id={`editButton${id}`}
      className={`btn-icon`}
      color="warning"
      disabled={isDisabled}
      onClick={() => handleClick()}
    >
      <Edit2 size={16} />
      {tooltipMessage && (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={`editButton${id}`}
          toggle={toggle}
          trigger="click hover"
        >
          <FormattedMessage
            id={'buttons.edit'}
            values={{ objectType: appIntl().formatMessage({ id: tooltipMessage }) }}
          />
        </Tooltip>
      )}
    </Button.Ripple>
  ) : null;
};

EditButton.defaultProps = {
  isDisabled: false
};

export default EditButton;
